export default {
  product: {
    monthlySubscription: {
      en: 'Monthly subscription',
    },
  },

  productsPerMonth: {
    en: '{count, plural, one {# product} other {# products}}/month',
  },

  freeTrial: {
    label: {
      en: 'Your subscription plan',
    },
    note: {
      en: '1 product/month. Starts from 2nd month',
    },
  },

  shipping: {
    en: 'Shipping',
  },

  tax: {
    en: 'Tax',
  },

  discount: {
    common: {
      en: 'Discount',
    },
    subscription: {
      en: 'Subscription discount',
    },
    secondMonthFree: {
      en: '2nd Month\'s {gender, select, female {Perfume} male {Cologne}}',
    },
    freeCORPerfume: {
      brand: 'Confessions of a Rebel',
      name: 'Get a room',
    },
  },

  offerNote: {
    en: 'Offer applied to the first month only',
  },

  caseSubscription: {
    en: 'Case subscription',
  },
  whiteCase: {
    en: 'White sleek case',
  },
  blackCase: {
    en: 'Black sleek case',
  },

  free: {
    en: 'Free',
  },

  yourGift: {
    en: 'Your gift',
  },

  upcharge: {
    label: {
      en: 'Premium upcharge',
    },
    note: {
      en: 'Full-size product',
    },
  },

  creditCardAuthorization: {
    en: 'Card authorization',
  },
  payPalAuthorization: {
    en: 'PayPal authorization',
  },

  resubscribe: {
    label: {
      en: 'Subscription discount',
    },
    months: {
      en: 'Next {months} months',
    },
    firstMonth: {
      en: 'Offer applied to the first month only',
    },
  },
}
